import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

export default function CompletionLineChart({ chartId, title, labels, data, height, containerStyle }) {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!chartId || !Array.isArray(labels) || !Array.isArray(data)) return;
    const ctx = document.getElementById(chartId);
    if (!ctx) return;

    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }

    chartRef.current = new Chart(ctx.getContext('2d'), {
      type: 'line',
      data: {
        labels,
        datasets: [
          {
            label: 'Completion %',
            data,
            fill: true,
            borderColor: 'rgba(14, 42, 85, 0.9)',
            backgroundColor: 'rgba(14, 42, 85, 0.15)',
            tension: 0.2,
            pointRadius: 3,
            pointHoverRadius: 5,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            title: { display: true, text: 'Report date' },
            ticks: { maxRotation: 45, minRotation: 0, maxTicksLimit: 10 },
          },
          y: {
            min: 0,
            max: 100,
            title: { display: true, text: 'Completion %' },
            ticks: { stepSize: 10 },
          },
        },
        plugins: {
          title: { display: true, text: title || 'Completion progress' },
          legend: { position: 'bottom' },
        },
      },
    });

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, [chartId, title, labels, data, height]);

  if (!chartId) return null;
  const h = typeof height === 'number' ? height : 200;
  return (
    <div style={{ width: '100%', maxWidth: '400px', margin: '0 auto', height: h, ...containerStyle }}>
      <canvas id={chartId} width="100%" height={h} />
    </div>
  );
}
